export default "__VITE_ASSET__atFjN$c7__"